import { strictify } from '~/utils/strictify'
import type { MenuSupportRequest } from '~/services/api/generated'
import { MenuSupportSuccessSchema } from '~/services/api/generated'
import { MenuSupport } from '~/services/api/contracts/requests/MenuSupport'

export function useSupportService() {
  const client = useApiRequest()

  return {
    submitMenuHelp: async (body: MenuSupportRequest) => {
      const request = MenuSupport({}).parse(body)
      const response = strictify(MenuSupportSuccessSchema).parse(
        await client('/api/support/menu-help', {
          method: 'POST',
          body: request
        })
      )
      return response
    }
  }
}
